import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
import { getRegionViewDefinition } from '../viewDefinitions';
const debug = process.env.REACT_APP_DEBUG && false;
export function RegionDetail(props) {
    const { contextObject: contextRegion, transactionFunctions, userFunctions, allowedActions, searchParams } = props;
    return (_jsx(Stack, { gap: 1, children: contextRegion && (_jsx(ObjectDetailCard, { mostProximateCustomer: undefined,
            matchedPrimary: contextRegion,
            transactionFunctions,
            userFunctions,
            allowedActions,
            searchParams,
            viewDefinition: getRegionViewDefinition(),
            deletable: true })) }));
}
